import { render, staticRenderFns } from "./QSnackbarNotices.vue?vue&type=template&id=75800d96&scoped=true&"
import script from "./QSnackbarNotices.vue?vue&type=script&lang=js&"
export * from "./QSnackbarNotices.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75800d96",
  null
  
)

export default component.exports